import type { IncidentStatus } from '../types/incident.types'

export const ALLOWED_TRANSITIONS: Record<IncidentStatus, IncidentStatus[]> = {
  DRAFT: ['NEW', 'CLOSED'],
  NEW: ['ACKNOWLEDGE', 'IN_PROGRESS', 'CLOSED'],
  ACKNOWLEDGE: ['IN_PROGRESS', 'BLOCKED', 'CLOSED'],
  IN_PROGRESS: ['BLOCKED', 'DONE', 'CLOSED'],
  BLOCKED: ['IN_PROGRESS', 'DONE', 'CLOSED'],
  DONE: ['CLOSED', 'IN_PROGRESS'],
  CLOSED: [],
}

export function canTransition(from: IncidentStatus, to: IncidentStatus): boolean {
  return ALLOWED_TRANSITIONS[from].includes(to)
}

export function nextStatuses(from: IncidentStatus): IncidentStatus[] {
  return ALLOWED_TRANSITIONS[from]
}
